// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"394":"PoseNet","443":"about","554":"对话","893":"products","918":"点评","961":"知识域"}[chunkId] || chunkId) + "." + {"394":"b872e6ce","443":"8cdcfe94","554":"fe81cc37","847":"cdaa4800","893":"bfa6e9fe","918":"fce4eb17","961":"fb0b6059"}[chunkId] + ".js";
};